export const CSV_FILE_TYPE = 'csv';

export const FileStatus = {
  NOT_UPLOADED: 'NotUploaded',
  UPLOADED: 'Uploaded',
  TYPE_ERROR: 'TypeError',
  MIN_SIZE_ERROR: 'MinSizeError',
  MAX_SIZE_ERROR: 'MaxSizeError',
};
